import React from 'react';

const AreaChartIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg className="ez-svg h-full" viewBox="0 0 552 600" {...props}>
      <g className="ez-fragment-cartesian-scale">
        <g className="ez-grid" stroke="rgba(168,168,168,1)">
          <g className="ez-grid-lines">
            <path
              className="ez-grid-line"
              d="M91.048 40v520m35.079-520v520m35.079-520v520m35.08-520v520m35.079-520v520m35.079-520v520m35.08-520v520m35.079-520v520m35.08-520v520m35.079-520v520m35.079-520v520M476.92 40v520M512 40v520"
            />
          </g>
          <g className="ez-grid-lines">
            <path
              className="ez-grid-line"
              d="M70 560h442M70 508h442M70 456h442M70 404h442M70 352h442M70 300h442M70 248h442M70 196h442M70 144h442M70 92h442M70 40h442"
            />
          </g>
        </g>
        <g className="ez-points">
          <g className="ez-area">
            <path
              d="M119.111 513.2 371.683 326l-112.254 83.2 7.015-5.2 140.318-104L189.27 461.2l42.095-31.2 35.08-26L70 549.6 512 222v338H70h196.444-77.174 217.492-147.333 112.254H119.11Z"
              fill="#ef476f80"
              className="ez-area-path"
            />
            <path
              d="M119.111 513.2 371.683 326l-112.254 83.2 7.015-5.2 140.318-104L189.27 461.2l42.095-31.2 35.08-26L70 549.6 512 222"
              stroke="#ef476f80"
              strokeWidth="2"
              fill="none"
              strokeLinejoin="round"
              strokeLinecap="round"
              className="ez-line"
            />
          </g>
        </g>
        <g textAnchor="middle" className="ez-axis">
          <path d="M70 566v-12 6h442v6-12" className="ez-axis-path" />
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M91.048 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(91.048 568)"
              className="ez-axis-tick-text"
            >
              5
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M126.127 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(126.127 568)"
              className="ez-axis-tick-text"
            >
              10
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M161.206 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(161.206 568)"
              className="ez-axis-tick-text"
            >
              15
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M196.286 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(196.286 568)"
              className="ez-axis-tick-text"
            >
              20
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M231.365 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(231.365 568)"
              className="ez-axis-tick-text"
            >
              25
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M266.444 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(266.444 568)"
              className="ez-axis-tick-text"
            >
              30
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M301.524 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(301.524 568)"
              className="ez-axis-tick-text"
            >
              35
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M336.603 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(336.603 568)"
              className="ez-axis-tick-text"
            >
              40
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M371.683 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(371.683 568)"
              className="ez-axis-tick-text"
            >
              45
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M406.762 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(406.762 568)"
              className="ez-axis-tick-text"
            >
              50
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M441.841 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(441.841 568)"
              className="ez-axis-tick-text"
            >
              55
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M476.92 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(476.92 568)"
              className="ez-axis-tick-text"
            >
              60
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M512 560v6" />
            <text
              y="9"
              dy=".6em"
              transform="translate(512 568)"
              className="ez-axis-tick-text"
            >
              65
            </text>
          </g>
        </g>
        <g textAnchor="end" className="ez-axis">
          <path d="M76 560H64h6V40h6-12" className="ez-axis-path" />
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 560h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 560)"
              className="ez-axis-tick-text"
            >
              0
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 508h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 508)"
              className="ez-axis-tick-text"
            >
              10
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 456h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 456)"
              className="ez-axis-tick-text"
            >
              20
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 404h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 404)"
              className="ez-axis-tick-text"
            >
              30
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 352h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 352)"
              className="ez-axis-tick-text"
            >
              40
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 300h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 300)"
              className="ez-axis-tick-text"
            >
              50
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 248h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 248)"
              className="ez-axis-tick-text"
            >
              60
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 196h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 196)"
              className="ez-axis-tick-text"
            >
              70
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 144h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 144)"
              className="ez-axis-tick-text"
            >
              80
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 92h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 92)"
              className="ez-axis-tick-text"
            >
              90
            </text>
          </g>
          <g className="ez-axis-tick">
            <path className="ez-axis-tick-line" d="M70 40h-6" />
            <text
              x="-9"
              dy=".3em"
              transform="translate(62 40)"
              className="ez-axis-tick-text"
            >
              100
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default AreaChartIcon;
